import React, { useEffect, useMemo, useState } from "react";
import './schoolDashboard.css';
import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from '@mui/material/Tooltip';
import Paper from "@mui/material/Paper";
import { TablePagination } from "@mui/material";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Input from '@mui/material/Input';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';

import schoolService from '../../features/school/schoolService'
import Spinner from "../Layout/Spinner";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import * as ld from 'lodash';

const CDS_REGEX = /^[0-9]{14}$/;
const itemsPerPageOptions = [250, 500, 750, 1000];


function SchoolDashboard(props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(itemsPerPageOptions[0]);
  // const {
  //   register: registerAddschool,
  //   handleSubmit: handleAddSchoolSubmit, 
  //   formState: { errors, ...formStateAliases }, 
  //   watch, 
  //   reset: resetRegiterForm,
  
  // } = useForm({
  //   mode: 'onChange',
  //   reValidateMode: 'onChange',
  //   defaultValues: {
  //     directlyFunded: "no",  // Default value for the "gender" radio button group
  //     grade: '' 
  //   }

  // });

  const {
    register: registerAddschool,
    handleSubmit: handleAddSchoolSubmit,
    formState: { errors }, // Only use errors for displaying validation messages
    watch,
    reset: resetRegiterForm,
    setValue: setFormValue,
  } = useForm({
    mode: 'onSubmit', // Only validate on form submit
    reValidateMode: 'onChange',
    defaultValues: {
      grade: '' // Set initial empty value for grade
    }
  });

  const selectedGrade = watch('grade'); 

  const {
    register: registerEditschool,
    handleSubmit: handleEditSchoolSubmit, 
    formState: { errors: editSchoolErrors }, watch: editwatch, reset: resetEditRegiterForm, setValue
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      directlyFunded: "no" // Default value for the "gender" radio button group
    }
  }
  );


  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpenAdd] = React.useState(false);
  const [openedit, setopenedit] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [countriesList, setCountriesList] = useState([]);
  const [county, setCounty] = useState('');
  const [districtsList, setDistrictsList] = useState([]);
  const [district, setDistrict] = useState('');
  const [schoolList, setSchoolList] = useState([])
  const [gradeList, setGradeList] = useState([]);
  const [deleteschoolId, setDeleteschoolId] = useState('');
  const [deletedTxt, setDeletedTxt] = useState('');
  const [editedschoolId, setEditedschoolId] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredSchoolList, setFilteredSchoolList] = useState([]);
  const [sortColumn, setSortColumn] = useState('SCHOOL NAME');
  const [sortDirection, setSortDirection] = useState('asc');
  const [fundVal, setFundVal] = useState('')
  const [gradeVal, setGradeVal] = useState('')

  // const sortdistrictlist = ld.sortBy(districtsList, ['name']);

  useEffect(() => {
    document.title = props.title

    setIsLoading(true);
    schoolService.getAllCounty().then((response) => {
      console.log(response.data.counties)
      setCountriesList(response.data.counties.length > 0 ? ld.orderBy(response.data.counties, [item => item.name.toLowerCase()], ['asc']) : response.data.counties);
      
      setIsLoading(false);

    }).catch((err) => {
      toast.error(err.message ? err.message : "Unable to fetch manage school data.");
      setIsLoading(false);
    })
  }, []);

  useEffect(() => {
    setDistrictsList('')
    setDistrict('');
    if (countriesList.length > 0) {
      let filterDist = countriesList.find((val, key) => {
        return val._id == county
      })

      // let newList = [...filterDist.districts];
      // let newSortedList = ld.orderBy(newList, [data => data.name.toLowerCase()], ['asc'])

        setDistrictsList(filterDist ? ld.orderBy(filterDist.districts, [data => data.name.toLowerCase()], ['asc']) : [])
    }

    if (!county) {
      setDistrict('');
    }
  }, [county]);

  const fetchSchoolList = () => {
    if (district) {
      setIsLoading(true)
      schoolService.getmanageschooldata({ districtId: district, academicyear:localStorage.getItem("academicyear") }).then((response) => {
        console.log(response.data.gradeList)
        setSchoolList(response.data.schoolList)
        setFilteredSchoolList(response.data.schoolList)
        setGradeList(response.data.gradeList)
        setIsLoading(false);
      }).catch(err => {
        toast.error(err.message ? err.message : "Unable to fetch manage school data.");
        setIsLoading(false);
      })
    } else {
      setSchoolList([])
    }
  }

  const getSchoolData = (schoolId) => {
    let schoolData = schoolList.find((val, key) => {
      return val._id == schoolId
    })

    return schoolData;
  }


  useEffect(() => {
    fetchSchoolList();
  }, [district])

  const getCountyName = () => {
    if (county) {
      let countyObj = countriesList.find((val, key) => {
        return val._id == county
      })

      return countyObj ? countyObj.name : ''
    }
    return '';
  }

  const getDistName = () => {
    if (county && district) {
      let distOj = districtsList.find((val, key) => {
        return val._id == district
      })

      return distOj ? distOj.name : ''
    }
    return '';
  }

  const onAddSchoolSubmit = (schoolData) => {
    console.log(schoolData)
    setIsLoading(true)
    schoolService.addschool({ ...schoolData, districtId: district }).then((result) => {
      toast.success("New School added successfully");
      setIsLoading(false);
      setOpenAdd(false);
      resetRegiterForm();
      fetchSchoolList();
    }).catch(err => {
      toast.error(err.message ? err.message : "Unable to add school.");
      setIsLoading(false);

    })
  }

  const onEditSchoolSubmit = (schoolData) => {
    console.log(schoolData)
    setIsLoading(true)
    schoolService.editschool({ ...schoolData, schoolId: editedschoolId, gradeId: gradeVal }).then((response) => {
      toast.success("New School added successfully");
      setIsLoading(false);
      setopenedit(false)
      setEditedschoolId('')
      fetchSchoolList();
    }).catch(err => {
      toast.error(err.message ? err.message : "Unable to edit school.");
      setIsLoading(false);
    })

  }




  const addDashboardDialog = () => {
    if (!county || !district) {
      toast.error("Please selected County and district")
    } else {
      setOpenAdd(true);
    }
  };

  const addDashboardClose = () => {
    setOpenAdd(false);
    resetRegiterForm()
  };

  const editDialogOpen = (schoolId) => {
    setEditedschoolId(schoolId)
    setopenedit(true)
  }

  const editDialogClose = () => {
    setopenedit(false)
    setEditedschoolId('')
  }

  useEffect(() => {
    console.log("editedschoolId before If:", editedschoolId);
    if (editedschoolId) {
      console.log("editedschoolId :", getSchoolData(editedschoolId).grade);
      
      let fundData = getSchoolData(editedschoolId).directlyFunded === 1 ? 'yes' : 'no'
      setValue('ncesId', getSchoolData(editedschoolId).ncesId);
      setValue('name', getSchoolData(editedschoolId).name);
      setFormValue('grade', getSchoolData(editedschoolId).grade);
      setFundVal(fundData);
      setGradeVal(getSchoolData(editedschoolId).gradeId)

    } else {
      setValue('ncesId', '');
      setValue('name', '');
      setFormValue('grade', '');
      setFundVal('no')
      setGradeVal('')
    }

  }, [editedschoolId]);

  // Watch the current value of grade (from react-hook-form)
  const watchedGrade = watch('gradeId'); 

  const deleteDashboardDialog = (schoolId) => {
    setDeleteschoolId(schoolId)
    setOpenDelete(true);
    console.log("deleted Id " + schoolId)

    let schoolData = getSchoolData(schoolId);
    setDeletedTxt(`Delete '${schoolData.name}' school in '${getCountyName()}' County and ${getDistName()} District with CDS Code '${schoolData.ncesId}' and Grade is ${schoolData.grade}`)
    // schoolService.deleteschool({})

  };

  const deleteDashboardClose = () => {
    setOpenDelete(false);
    setDeleteschoolId('')
    setDeletedTxt('')

  };

  const deleteSchoolSubmit = () => {
    console.log(deleteschoolId);
    setIsLoading(true)
    schoolService.deleteschool({ schoolId: deleteschoolId }).then((result) => {
      toast.success("School deleted successfully");
      setOpenDelete(false);
      setDeleteschoolId('')
      setDeletedTxt('')
      setIsLoading(false)
      fetchSchoolList();
    }).catch(err => {
      toast.error(err.message ? err.message : "Unable to delete school.");
      setIsLoading(false);
    })
  }

  const onCountrySelect = (event) => {
    setCounty('')
    setDistrict('')
    setCounty(event.target.value)
  };

  const onDistrictSelect = (event) => {
    setDistrict('')
    setDistrict(event.target.value)
  };
  // Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top


  const ITEM_HEIGHT = 34;
  const ITEM_PADDING_TOP = 4;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };

  const handleSort = (column) => {
    // If the same column is clicked again, toggle the sort direction
    if (sortColumn === column) {
      setSortDirection((prevDirection) =>
        prevDirection === 'asc' ? 'desc' : 'asc'
      );
    } else {
      // If a new column is clicked, set the column and sort direction
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const sortedAndFilteredSchoolList = useMemo(() => {
    let sortedAndFilteredList = [...schoolList];

    if (searchQuery) {
      sortedAndFilteredList = sortedAndFilteredList.filter((schoolRow) =>
        schoolRow.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (sortColumn === 'SCHOOL CODE') {
      sortedAndFilteredList.sort((a, b) => {
        if (sortDirection === 'asc') {
          return a.ncesId.localeCompare(b.ncesId);
        } else {
          return b.ncesId.localeCompare(a.ncesId);
        }
      });
    }

    if (sortColumn === 'SCHOOL NAME') {
      sortedAndFilteredList.sort((a, b) => {
        if (sortDirection === 'asc') {
          return a.name.localeCompare(b.name);
        } else {
          return b.name.localeCompare(a.name);
        }
      });
    }

    if (sortColumn === 'FUNDED') {
      sortedAndFilteredList.sort((a, b) => {
        const valueA = a.directlyFunded.toString();
        const valueB = b.directlyFunded.toString();

        if (sortDirection === 'asc') {
          return valueA.localeCompare(valueB);
        } else {
          return valueB.localeCompare(valueA);
        }
      });
    }

    if (sortColumn === 'GRADE') {
      sortedAndFilteredList.sort((a, b) => {
        if (sortDirection === 'asc') {
          return a.grade.localeCompare(b.grade);
        } else {
          return b.grade.localeCompare(a.grade);
        }
      });
    }

    return sortedAndFilteredList;
  }, [schoolList, sortColumn, sortDirection, searchQuery]);

  const changeEditGrade = (event) => {
    console.log("gradeVal : ", event);
    let value = event.target.value
    console.log("gradeVal : ", value);
    setGradeVal(value)
  }

  const startRowIndex = page * rowsPerPage;
  const endRowIndex = startRowIndex + rowsPerPage;
  const displayedRows = sortedAndFilteredSchoolList.slice(startRowIndex, endRowIndex);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleYearSelection = () => {
    toast.error("Restricted in historical data view");
  };



  return (
    <>
      {(isLoading === true) ? <Spinner></Spinner> : ""}
      <div className='pageHeader'>
        <div className="pageText">Manage Schools</div>
      </div>
      <div className='pageContent'>
        <div className='dash_UserDetails'>

          <div className='dash_countyDetails'>
            <FormControl className="text-inside-grid" variant="standard" sx={{ minWidth: 400 }}>
              <InputLabel id="demo-simple-select-standard-label">Select County</InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={county}
                onChange={onCountrySelect}
                label="Country"
                MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
              >
                <MenuItem value="">
                  <em>Select a county</em>
                </MenuItem>
                {countriesList ? countriesList.map((country) => (
                  <MenuItem key={country._id} value={country._id}>
                    {country.name}
                  </MenuItem>
                )) : ''}
              </Select>
            </FormControl>
          </div>
          <div className='dash_districtDetails'>
            <FormControl className="text-inside-grid" variant="standard" sx={{ minWidth: 400 }}>
              <InputLabel id="demo-simple-select-standard-label">Select District</InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={district}
                onChange={onDistrictSelect}
                label="District"
                MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
              >
                <MenuItem value="">
                  <em>Select a district</em>
                </MenuItem>
                {/* {districtsList && districtsList.map((dist) => ( */}
                {districtsList && districtsList.map((dist) => (
                  <MenuItem key={dist._id} value={dist._id}>
                    {dist.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {localStorage.getItem('academicyear') === 'currentyear' && (
          <div className='dash_addDashUser'>
            <span><Fab size="small" color="primary" aria-label="add" className='dash_addButton' onClick={addDashboardDialog}>< AddBusinessIcon /></Fab></span>
          </div>
          )}
        </div>
        <div className='dash_filterInput'>
          <Box
            component="form"
            sx={{
              '& > :not(style)': { width: '100%' },
            }}
            noValidate
            autoComplete="off"
          >
            <TextField id="dash_filterInpText" label="FILTER" variant="standard"
              value={searchQuery}
              onChange={handleSearch}
            />
          </Box>
        </div>
        <div className='dash_userTable'>
          <TableContainer component={Paper} sx={{ height: "60vh" }}>
            <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" className='dash_tableHeader' onClick={() => handleSort('SCHOOL CODE')}>
                    SCHOOL CODE
                    {sortColumn === 'SCHOOL CODE' && (
                      <span>{sortDirection === 'asc' ? ' ▲' : ' ▼'}</span>
                    )}
                  </TableCell>
                  <TableCell align="left" className='dash_tableHeader' onClick={() => handleSort('SCHOOL NAME')}>
                    SCHOOL NAME
                    {sortColumn === 'SCHOOL NAME' && (
                      <span>{sortDirection === 'asc' ? ' ▲' : ' ▼'}</span>
                    )}

                  </TableCell>
                  <TableCell align="left" className='dash_tableHeader' onClick={() => handleSort('FUNDED')}>
                    FUNDED
                    {sortColumn === 'FUNDED' && (
                      <span>{sortDirection === 'asc' ? ' ▲' : ' ▼'}</span>
                    )}
                  </TableCell>
                  <TableCell align="left" className='dash_tableHeader' onClick={() => handleSort('GRADE')}>
                    GRADE
                    {sortColumn === 'GRADE' && (
                      <span>{sortDirection === 'asc' ? ' ▲' : ' ▼'}</span>
                    )}
                  </TableCell>
                  <TableCell align="left" className='dash_tableHeader'>E-SCHOOL URL CODE</TableCell>
                  <TableCell align="left" className='dash_tableHeader'>M-SCHOOL URL CODE</TableCell>
                  <TableCell align="left" className='dash_tableHeader'>H-SCHOOL URL CODE</TableCell>
                  <TableCell align="left" className='dash_tableHeader'>STAFF URL CODE</TableCell>
                  <TableCell align="left" className='dash_tableHeader'>PARENT URL CODE</TableCell>
                  <TableCell align="left" className='dash_tableHeader'>ACTIONS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayedRows.length > 0 ?
                  displayedRows.map((schoolRow) => (
                    <TableRow
                      key={schoolRow._id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell scope="row" className='dash_tableBody'>{schoolRow.ncesId}</TableCell>
                      <TableCell align="left" className='dash_tableBody dash_email_column'>{schoolRow.name}</TableCell>
                      <TableCell align="left" className='dash_tableBody'>{schoolRow.directlyFunded}</TableCell>
                      <TableCell align="left" className='dash_tableBody'>{schoolRow.grade}</TableCell>
                      <TableCell align="left" className='dash_tableBody dash_date_column'>{schoolRow.shortCode.es_schoolLinkCode}</TableCell>
                      <TableCell align="left" className='dash_tableBody dash_date_column'>{schoolRow.shortCode.ms_schoolLinkCode}</TableCell>
                      <TableCell align="left" className='dash_tableBody dash_date_column'>{schoolRow.shortCode.schoolLinkCode}</TableCell>
                      <TableCell align="left" className='dash_tableBody dash_date_column'>{schoolRow.shortCode.staffLinkCode}</TableCell>
                      <TableCell align="left" className='dash_tableBody dash_date_column'>{schoolRow.shortCode.parentLinkCode}</TableCell>
                      <TableCell align="left" className='dash_tableBody'>
                      <div className="dash_actionButton">
                        {localStorage.getItem("academicyear") === 'currentyear' ? (
                          <Tooltip title='Edit user details' placement="top-start">
                              <span href="" onClick={() => { editDialogOpen(schoolRow._id) }}><img alt="Edit School" src={require("../../assets/images/editDC.png")} mattooltip="Edit user details" className="dash_action_imge"></img></span>
                          </Tooltip>
                          ) : (
                            <Tooltip title='Edit user details' placement="top-start">
                            <span href="" onClick={() => { handleYearSelection() }}><img alt="Edit School" src={require("../../assets/images/editDC.png")} mattooltip="Edit user details" className="dash_action_imge"></img></span>
                            </Tooltip>
                          )}
                          {localStorage.getItem("academicyear") === 'currentyear' ? (
                            <Tooltip title='Delete school/user' placement="top-start">
                            <span href="" onClick={() => { deleteDashboardDialog(schoolRow._id) }}><img alt="Delete School" src={require("../../assets/images/deleteDC.png")} mattooltip="Delete user details" className="dash_action_imge"></img></span>
                            </Tooltip>
                          ) : (
                            <Tooltip title='Delete school/user' placement="top-start">
                            <span href="" onClick={() => { handleYearSelection() }}><img alt="Delete School" src={require("../../assets/images/deleteDC.png")} mattooltip="Delete user details" className="dash_action_imge"></img></span>
                            </Tooltip>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))

                  : ""}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={itemsPerPageOptions}
            component="div"
            count={sortedAndFilteredSchoolList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>

      {/* add school */}
      <Dialog
        open={open}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "400px",  // Set your width here
            },
          },
        }} onClose={addDashboardClose}
        aria-labelledby="addDashboardLabel"
        aria-describedby="addDashboardDescription"
      >
        <DialogTitle id="addDashboardTitle">
          ADD SCHOOL
        </DialogTitle>
        <DialogContent sx={{ widdth: '100%' }}>
          <DialogContentText id="addDashboardDescription">
            <form onSubmit={handleAddSchoolSubmit(onAddSchoolSubmit)}>

              <TextField
                autoFocus
                margin="dense"
                label="County Name"
                disabled='true'
                type="text"
                value={getCountyName()}
                inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label              fullWidth
                fullWidth
                variant="standard"
                sx={{
                  marginTop: '0px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px",
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "#000000",
                  }
                }}
              />

              <TextField
                autoFocus
                margin="dense"
                id="districtName"
                label="District Name"
                disabled='true'
                type="text"
                value={getDistName()}
                inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label              fullWidth
                fullWidth
                variant="standard"
                sx={{
                  marginTop: '20px', backgroundColor: '#eeeeee',
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "#000000",
                  }
                }}
              />
              <TextField
                autoFocus
                margin="dense"
                id="cdsCode"
                label="CDS Code"
                type="text"
                inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label              fullWidth
                fullWidth
                variant="standard"
                sx={{ marginTop: '20px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px", }}
                {...registerAddschool("ncesId", { required: true, pattern: CDS_REGEX, maxLength: 14, minLength: 14 })}
              />
              {errors.ncesId && (
                <span className="errorClassschool">
                  CDS CODE must be of 14 digits
                </span>
              )}
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="School Name"
                inputProps={{ style: { fontSize: 13, width: '100%', padding: '0px 5px 5px 5px', color: '#000000' } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '0px 5px 5px 5px', color: '#000000' } }} // font size of input label              fullWidth
                type="name"
                fullWidth
                variant="standard"
                sx={{ marginTop: '20px', backgroundColor: '#eeeeee', paddingLeft: '5px', borderRadius: "5px 5px 0px 0px", }}
                {...registerAddschool("name", { required: true })}

              />
              {errors.name && (
                <span className="errorClassschool">
                  You must provide a School Name
                </span>
              )}
              <div className="ddClass">
                <div style={{ width: '50%' }}>
                  <InputLabel style={{ fontSize: '12px' }}>Funded</InputLabel>
                  <Select
                    id="dash_schools"
                    autoFocus
                    placeholder="Funded"
                    className="dash_schools_drpdown"
                    inputProps={{ style: { fontSize: 13, width: '100%', padding: '0', color: '#000000' } }} // font size of input text
                    InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '0', color: '#000000' } }} // font size of input label              fullWidth

                    sx={{ width: '95%', backgroundColor: '#eeeeee', margin: '0px', paddingLeft: '5px', borderRadius: "5px 5px 0px 0px", }}
                    fullWidth
                    input={<Input />}
                    {...registerAddschool('directlyFunded')}
                    defaultValue="no"

                  >
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </Select>

                </div>
                <div style={{ width: '50%' }}>
                  <InputLabel style={{ fontSize: '12px' }}>Grade</InputLabel>
                  <Select
                    id="dash_schools"
                    autoFocus
                    placeholder="garde"
                    value={selectedGrade || ''} 
                    className="dash_schools_drpdown"
                    inputProps={{ style: { fontSize: 13, width: '100%', padding: '0', color: '#000000' } }} // font size of input text
                    InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '0', color: '#000000' } }} // font size of input label              fullWidth
                    sx={{ width: '95%', backgroundColor: '#eeeeee', margin: '0px', borderRadius: "5px 5px 0px 0px", }}
                    fullWidth
                    input={<Input />}
                    {...registerAddschool('grade', { required: 'You must provide a Grade' })}
                  >
                    {gradeList ? gradeList.map((val) => (
                      <MenuItem key={val._id} value={val._id}>{val.name}</MenuItem>
                    )) : ''}

                  </Select>
                  {errors.grade && !selectedGrade && (
                    <span className="errorClassschool">
                       {errors.grade.message}
                    </span>
                  )}
                </div>
              </div>

              <div style={{ marginTop: "40px" }}>
                <Button type="submit" variant="contained" className="dash_save_button">Save</Button>
                <Button variant="contained" onClick={addDashboardClose} className="dash_cancel_button" autoFocus> Cancel </Button>
              </div>
            </form>
          </DialogContentText>
        </DialogContent>

      </Dialog>
      {/* add end */}

      {/* edit school */}
      <Dialog
        open={openedit}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "400px",  // Set your width here
            },
          },
        }} onClose={editDialogClose}
        aria-labelledby="addDashboardLabel"
        aria-describedby="addDashboardDescription"
      >
        <DialogTitle id="addDashboardTitle">
          EDIT SCHOOL
        </DialogTitle>
        <DialogContent sx={{ widdth: '100%' }}>
          <DialogContentText id="addDashboardDescription">
            <form onSubmit={handleEditSchoolSubmit(onEditSchoolSubmit)}>

              <TextField
                autoFocus
                margin="dense"
                label="County Name"
                disabled='true'
                type="text"
                value={getCountyName()}
                inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label              fullWidth
                fullWidth
                variant="standard"
                sx={{
                  marginTop: '0px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px",
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "#000000",
                  }
                }}
              />

              <TextField
                autoFocus
                margin="dense"
                id="districtName"
                label="District Name"
                disabled='true'
                type="text"
                value={getDistName()}
                inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label              fullWidth
                fullWidth
                variant="standard"
                sx={{
                  marginTop: '20px', backgroundColor: '#eeeeee',
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "#000000",
                  }
                }}
              />
              <TextField
                autoFocus
                margin="dense"
                id="cdsCode"
                label="CDS Code"
                disabled='true'
                type="text"
                inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label              fullWidth
                fullWidth
                variant="standard"
                sx={{ marginTop: '20px', backgroundColor: '#eeeeee', borderRadius: "5px 5px 0px 0px", }}
                {...registerEditschool("ncesId", { required: true, pattern: CDS_REGEX, maxLength: 16 })}
              />
              {editSchoolErrors.ncesId && (
                <span className="errorClassschool">
                  CDS CODE must be of 14 digits
                </span>
              )}
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="School Name"
                inputProps={{ style: { fontSize: 13, width: '100%', padding: '0px 5px 5px 5px', color: '#000000' } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '0px 5px 5px 5px', color: '#000000' } }} // font size of input label              fullWidth
                type="name"
                fullWidth
                variant="standard"
                sx={{ marginTop: '20px', backgroundColor: '#eeeeee', paddingLeft: '5px', borderRadius: "5px 5px 0px 0px", }}
                {...registerEditschool("name", { required: true })}

              />
              {editSchoolErrors.name && (
                <span className="errorClassschool">
                  You must provide a School Name
                </span>
              )}
              <div className="ddClass">
                <div style={{ width: '50%' }}>
                  <InputLabel style={{ fontSize: '12px' }}>Funded</InputLabel>
                  <Select
                    id="dash_schools"
                    autoFocus
                    placeholder="Funded"
                    className="dash_schools_drpdown"
                    inputProps={{ style: { fontSize: 13, width: '100%', padding: '0', color: '#000000' } }} // font size of input text
                    InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '0', color: '#000000' } }} // font size of input label              fullWidth
                    // onChange={select}
                    sx={{ width: '95%', backgroundColor: '#eeeeee', margin: '0px', paddingLeft: '5px', borderRadius: "5px 5px 0px 0px", }}
                    fullWidth
                    defaultValue={fundVal}
                    input={<Input />}
                    {...registerEditschool('directlyFunded')}
                  >
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </Select>
                </div>
                <div style={{ width: '50%' }}>
                  <InputLabel id="dash_schoolsdv" style={{ fontSize: '12px' }}>Grade</InputLabel>
                  <Select
                    id="dash_schools"
                    autoFocus
                    placeholder="grade"
                    className="dash_schools_drpdown"
                    inputProps={{ style: { fontSize: 13, width: '100%', padding: '0', color: '#000000' } }} // font size of input text
                    InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '0', color: '#000000' } }} // font size of input label              fullWidth
                    sx={{ width: '95%', backgroundColor: '#eeeeee', margin: '0px', borderRadius: "5px 5px 0px 0px", }}
                    fullWidth
                    value={ gradeVal || ''}
                    input={<Input />}
                    onChange={changeEditGrade}
                    // {...registerEditschool('gradeId', { required: true })}
                  >
                    {gradeList ? gradeList.map((val) => (
                      <MenuItem key={val._id} value={val._id}>{val.name}</MenuItem>
                    )) : ''}

                  </Select>
                  {editSchoolErrors.gradeId && gradeVal && (
                    <span className="errorClassschool">
                      You must provide a Grade
                    </span>
                  )}
                </div>
              </div>

              <div style={{ marginTop: "40px" }}>
                <Button type="submit" variant="contained" className="dash_save_button">Save</Button>
                <Button variant="contained" onClick={editDialogClose} className="dash_cancel_button" autoFocus>Cancel</Button>
              </div>
            </form>
          </DialogContentText>
        </DialogContent>

      </Dialog>
      {/* openedit end */}

      {/* delete dialoge */}
      <Dialog
        open={openDelete}
        onClose={deleteDashboardClose}
        aria-labelledby="deleteDashboardLabel"
        aria-describedby="deleteDashboardDescription"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "400px",  // Set your width here
            },
          },
        }}
      >
        <DialogTitle id="deleteDashboardTitle" className="deleteDashboardTitle">
          Delete School
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="deleteDashboardDescription">
            <div className="deleteInfo">
              {deletedTxt}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="school_dash_actionButton">
          <Button variant="contained" onClick={deleteDashboardClose} className="school_dash_no_button" autoFocus> No </Button>
          <Button variant="contained" className="dash_yes_button" onClick={deleteSchoolSubmit}>Yes</Button>
        </DialogActions>
      </Dialog>

      {/* dlete dialoge end */}

    </>
  )
}

export default SchoolDashboard